import * as React from 'react'
import { useAtom } from 'infrastructure/state/jotai.wrapper'
import { useKiddomStandards } from './hooks'
import { kiddomStandardsAtom } from './atoms'
import { renderLoading, renderMessage } from './utility'
import { KiddomStandardsView } from './KiddomStandardsView'

interface KiddomStandardsProps {
  state: string
  subject: string
}

export const KiddomStandards: React.FC<KiddomStandardsProps> = ({
  state,
  subject,
}) => {
  const { loadingKiddomStandards, fetchKiddomStandards } = useKiddomStandards()
  const [kiddomStandards, setKiddomStandards] = useAtom(kiddomStandardsAtom)

  // Clear data when state or subject changes
  React.useEffect(() => {
    setKiddomStandards(null)
  }, [state, subject, setKiddomStandards])

  // Fetch standards when both state and subject are available
  React.useEffect(() => {
    if (state && subject && !kiddomStandards && !loadingKiddomStandards) {
      fetchKiddomStandards(state, subject).then((result) => {
        if (result) {
          setKiddomStandards(result)
        }
      })
    }
  }, [
    state,
    subject,
    kiddomStandards,
    loadingKiddomStandards,
    fetchKiddomStandards,
    setKiddomStandards,
  ])

  // Check if both state and subject are selected
  if (!state || !subject) {
    return renderMessage('Select state and subject')
  }

  // Check if standards are loading or not loaded yet
  if (!kiddomStandards) {
    return renderLoading(`Loading standards for ${state} ${subject}`)
  }

  return <KiddomStandardsView state={state} subject={subject} />
}
